import { Descriptions } from 'antd';
import * as React from 'react';
import { IOrderInfo } from 'src/entity/OrderEntity';

interface IInstitutionInfoProps {
 /** 订单明细 */
 orderInfo: IOrderInfo;
}

class InstitutionInfo extends React.Component<IInstitutionInfoProps> {
  render() {
    const { institution_name, doctor_name, doctor_mobile } = this.props.orderInfo;

    return (
      <div className="div-row">
        <div className="div-col-3 text-align-right">医疗机构</div>
        <div className="div-col-15 order_info">
          <Descriptions title="" bordered={false}>
            <Descriptions.Item label="机构名称">
              {institution_name}
            </Descriptions.Item>
            <Descriptions.Item label="管理员/医生">
              {doctor_name}
            </Descriptions.Item>
            <Descriptions.Item label="手机号">
              {doctor_mobile}
            </Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    );
  }
}

export default InstitutionInfo;



// WEBPACK FOOTER //
// ./src/components/views/Order/components/InstitutionInfo.tsx